<template>
    <div class="q-radio-container" @click="onClick">
        <img v-if="!checked" src="@common/assets/images/check-not-checked.png" alt="">
        <img v-else src="@common/assets/images/check-checked.png" alt="">
        <span class="q-radio-text">{{ text }}</span>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
    value: {
        type: Boolean,
        default: false,
    },
    text: {
        type: String,
        default: 'xxx',
    },
});
const emit = defineEmits(['input', 'change']);
const checked = computed({
    get() {
        return props.value;
    },
    set(val) {
        emit('input', val);
    },
});

const onClick = () => {
    emit('input', !checked.value);
    emit('change', !checked.value);
};
</script>
<style lang="scss" scoped>
.q-radio-container {
    display: flex;
    align-items: center;
    img {
        margin-right: 4px;
        width: 22px;
        height: 22px;
    }
}
.q-radio-text {
    font-weight: bold;
    font-size: 22px;
    color: #440A0A;
    line-height: 32px;
    white-space: nowrap;
}
</style>
